import { createStore } from 'owa-satcheljs';
import type { MailboxInfo } from 'owa-client-types';

export interface MailManualSyncStore {
    isSyncingMailbox: boolean;
}

const mailManualSyncStoreMap = new Map<string, MailManualSyncStore>();

export function getMailManualSyncStore(mailboxInfo: MailboxInfo): MailManualSyncStore {
    // Use both userIdentity and mailboxSmtpAddress to get a unique value across mailboxes.
    const name = `${mailboxInfo.userIdentity}_${mailboxInfo.mailboxSmtpAddress}_mailManualSyncStore`;
    let cachedStore = mailManualSyncStoreMap.get(name);
    if (!cachedStore) {
        /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
         * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
         *	> Function should only be invoked in module scope */
        const store = createStore<MailManualSyncStore>(name, { isSyncingMailbox: false })();
        mailManualSyncStoreMap.set(name, store);
        cachedStore = store;
    }
    return cachedStore;
}
